/** A link that sits quietly in a line of muted text. */
export const quietLink = "hover:text-foreground hover:underline";

/** The notice Google asks for wherever reCAPTCHA runs, inline in a line of other text. */
export function RecaptchaNotice() {
  return (
    <span>
      Protected by reCAPTCHA (
      <a
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer"
        className={quietLink}
      >
        Google Privacy
      </a>
      ,{" "}
      <a
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer"
        className={quietLink}
      >
        Terms
      </a>
      )
    </span>
  );
}

export function RecaptchaAttribution() {
  return (
    <p className="text-[11px] leading-relaxed text-muted-foreground">
      <RecaptchaNotice />
    </p>
  );
}
